import { CareGiverDTO } from '@maiia/model/generated/model/api-patient/api-patient';
import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { asyncActions } from '@docavenue/core';
import { useCurrentUser } from '@docavenue/components';
import { isCompleted } from '@/components/molecules/WithAuth/functions';
import { careTeamActions } from '../actions';
import { PatientUser } from '@/components/molecules/WithAuth/types';

const useCareTeam = () => {
  const dispatch = useDispatch();
  const currentUser = useCurrentUser<PatientUser>();
  return useQuery<CareGiverDTO[]>({
    queryKey: ['careTeam'],
    queryFn: () =>
      asyncActions(dispatch, careTeamActions.getList()).then(res => res.items),
    enabled: currentUser && isCompleted(currentUser, true) === true,
  });
};

export default useCareTeam;
